import { ProductVisibilityType } from "@omni/types/api/product/bff/shared/enums/productVisibilityType.enum";
import { cn } from "@omni/utils/styles";

import { ECommerce as ECommerceBase } from "@/components/Product/ECommerce/eCommerce";
import { useECommerceProduct } from "@/components/Product/ECommerce/hooks/useECommerceProduct.hook";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { DeliveryItem as DeliveryItemBase } from "./components/deliveryTypes/deliveryItem/deliveryItem";
import { Delivery as DeliveryBase } from "./delivery";

const DeliveryDefault = () => {
    const { t } = useGranite();

    const { isWebOnly, hasDelivery, visibilityType } = useECommerceProduct();

    const onlyHomeDelivery = visibilityType === ProductVisibilityType.Delivery;
    const onlyAvailableInStore =
        visibilityType === ProductVisibilityType.OnlyAvailableInStore;

    return (
        <>
            <DeliveryBase.NoDelivery />
            {onlyAvailableInStore && !isWebOnly && (
                <DeliveryBase.OnlyAvailableInStore
                    displayEcommerceText={true}
                />
            )}
            {hasDelivery && !onlyAvailableInStore && (
                <div>
                    <div className={cn("tw:flex tw:flex-col tw:mb-4")}>
                        <p className={cn("tw:w-full tw:mb-2")}>
                            {t("ecommerce.title.delivery")}
                        </p>
                        <DeliveryBase.Types>
                            <DeliveryItemBase>
                                <DeliveryItemBase.Info>
                                    <DeliveryItemBase.Info.DeliveryCost />
                                </DeliveryItemBase.Info>
                                <DeliveryItemBase.HomeDelivery />
                                <DeliveryItemBase.ClickAndCollect />
                                <DeliveryItemBase.AdditionalServices />
                            </DeliveryItemBase>
                        </DeliveryBase.Types>
                    </div>
                    {onlyHomeDelivery && !isWebOnly && (
                        <div className={cn("tw:mb-4")}>
                            <DeliveryBase.OnlyAvailableInStore
                                displayEcommerceText={false}
                            />
                        </div>
                    )}

                    <DeliveryBase.ProductConfiguration />

                    <div className={cn("tw:flex tw:flex-col")}>
                        <p className={cn("tw:w-full tw:mb-2")}>
                            {t("ecommerce.label.amount")}
                        </p>
                        <div
                            className={cn(
                                "tw:flex tw:mb-2 tw:justify-between tw:items-center"
                            )}
                        >
                            <div className={cn("tw:min-w-26 tw:md:w-auto")}>
                                <DeliveryBase.Amount />
                            </div>
                            <ECommerceBase.WishlistButton />
                        </div>
                        <ECommerceBase.OrderButton />
                    </div>
                </div>
            )}
        </>
    );
};

export { DeliveryDefault };
